'use client';

import { getMaturityModel } from '@/domain/products/api';
import { useQuery } from '@tanstack/react-query';

import MaturitySection from './MaturitySection';

interface MaturitySectionWrapperProps {
  idProduct: number;
  idMaturityModel: number;
}

const MaturitySectionWrapper = ({ idProduct, idMaturityModel }: MaturitySectionWrapperProps) => {
  const { data: maturity, isLoading } = useQuery({
    queryKey: ['maturity-model', idProduct, idMaturityModel],
    queryFn: () => getMaturityModel(idProduct, idMaturityModel),
  });

  if (isLoading || !maturity) {
    return null;
  }

  return <MaturitySection idProduct={idProduct} maturity={maturity} />;
};

export default MaturitySectionWrapper;
